export default "__VITE_ASSET__C_cpMgz8__"